export const filterData = ({ data, key, fields = [] }) => {
  let currentValue = null;
  const listDataFilter = [];

  for (const item of data) {
    if (item[key] !== currentValue) {
      if (item[key]) {
        const object = selectedField(item, fields);
        listDataFilter.push(object);
        currentValue = item[key];
      }
    }
  }

  return listDataFilter;
};

export const selectedField = (obj = {}, fields = []) => {
  fields = new Set(fields);
  const final = {};
  const keyOfCopy = Object.keys(obj).filter((key) => fields.has(key));

  for (const key of keyOfCopy) {
    final[key] = obj[key];
  }

  return final;
};

export const isInvalidFileData = (data) => {
  const listField = [
    "Tỉnh Thành Phố",
    "Mã TP",
    "Quận Huyện",
    "Mã QH",
    "Phường Xã",
    "Mã PX",
    "Cấp",
    "Tên Tiếng Anh",
  ];
  return Object.keys(data).every((field) => listField.includes(field));
};

export const convertExcelData = (data) => {
  const listAdministrative = data.map((administrative) => ({
    provinceName: administrative["Tỉnh Thành Phố"],
    provinceCode: administrative["Mã TP"],
    districtName: administrative["Quận Huyện"],
    districtCode: administrative["Mã QH"],
    wardName: administrative["Phường Xã"],
    wardCode: administrative["Mã PX"],
  }));

  return listAdministrative;
};

export const defaultProvince = {
  provinceName: "Tỉnh/Thành Phố",
  provinceCode: "00",
  id: "1",
};

export const defaultDistrict = {
  districtName: "Quận/Huyện",
  provinceCode: defaultProvince.provinceCode,
  districtCode: "000",
  id: "1",
};

export const defaultWard = {
  wardName: "Phường/Xã",
  wardCode: "00000",
  districtCode: defaultDistrict.districtCode,
  id: "1",
};
